import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './Redux/store';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>

    <App />
    </Provider>
  </React.StrictMode>
);
// Force reload only once in any environment
if (!localStorage.getItem('reloadedOnce')) {
  localStorage.setItem('reloadedOnce', 'true'); // Mark reload as done
  window.location.reload(true); // Force a hard reload bypassing cache
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  // Unregister all service workers
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const reg of registrations) reg.unregister();
  });

  // Also try to remove the controller to stop SW from intercepting
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg && reg.active) {
      reg.active.postMessage({ type: 'SKIP_WAITING' });
    }
  });
}

// Clear common PWA caches (Workbox, etc.)
if (window.caches && caches.keys) {
  caches.keys().then((keys) => {
    keys.forEach((k) => caches.delete(k));
  });
}